import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import "@mui/icons-material";

import "./home.css";
import { MovieContainer } from "./MovieCard/MovieCard.js";
import { newsData, released, Upcoming } from "./MovieCard/Movies.js";
import Footer from "./Footer/Footer.js";
import ParentNavBar from "./Navbar/ParenComponent.js";
import GradientWrapper from "./GradientWrapper/GradientWrapper.js";
import { useNavigate } from "react-router-dom";
import NewsCard from "./NewsCard/News.js";
import "./CalRomalSTylesheet/stylesheet.css";
import { List, ListItem } from "@mui/material";

const Home = () => {
  const navigate = useNavigate();

  const containerRef = useRef(null);
  const imageRef = useRef(null);

  useGSAP(
    () => {
      const handleMouseMove = (event) => {
        const { clientX, clientY } = event;
        const { innerWidth, innerHeight } = window;

        const xPercent = (clientX / innerWidth - 0.5) * -0.3;
        const yPercent = (clientY / innerHeight + 0.5) * -0.3;
        console.log(clientX / innerWidth - 0.5, xPercent * 50);
        gsap.to(imageRef.current, {
          x: xPercent * 50,
          y: yPercent * 50,
          duration: 0.5,
          ease: "power3.out",
          translateX: "-50%",
        });
      };

      const container = containerRef.current;
      if (container) {
        container.addEventListener("mousemove", handleMouseMove);
      }

      return () => {
        if (container) {
          container.removeEventListener("mousemove", handleMouseMove);
        }
      };
    },
    { scope: containerRef }
  );
  return (
    <>
      <GradientWrapper>
        <ParentNavBar />
        <div className="container" ref={containerRef}>
          <div className="parallax-image" ref={imageRef}>
            {/* <div
              style={{
                zIndex: 1000000,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: "center",
                position: "relative",
                top: -30,
                textAlign: "center",
                paddingLeft: 40,
                paddingRight: 40,
                paddingBottom: 40,
              }}
            >
              <p className="name">Sharron Aubrey</p>
              <p className="title">CEO, Actor, Producer & Screenwriter</p>
              <p className="namelogo">English Productions</p>
              <a
                className="newsUpdateButton"
                // onClick={() => {
                //   navigate("/news");
                // }}
                href="#News"
              >
                News Update
              </a>
            </div> */}
          </div>
          <div
            style={{
              // zIndex: 1000000,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "center",
              position: "relative",
              top: -30,
              textAlign: "center",
              paddingLeft: 40,
              paddingRight: 40,
              paddingBottom: 40,
            }}
          >
            <span className="name">
              <span
                className="name"
                style={{
                  fontSize: "5rem",
                }}
              >
                S
              </span>
              harron{" "}
              <span
                className="name"
                style={{
                  fontSize: "5rem",
                }}
              >
                A
              </span>
              ubrey
            </span>
            <p className="title">Actor, Producer, Screenwriter</p>
            <p className="title">CEO & Artistic Director</p>
            <p className="namelogo">English Productions</p>
            <a
              className="newsUpdateButton"
              // onClick={() => {
              //   navigate("/news");
              // }}
              href="#News"
            >
              News Update
            </a>
          </div>
        </div>
        <div
          id="News"
          style={{
            paddingLeft: 40,
            // justifyContent: "center",
            // alignItems: "center",
            display: "flex",
            width: "100%",
            paddingTop: 20,
          }}
        >
          <p
            style={{
              fontSize: "1.6rem",
              width: "fit-content",
              // color: "#696868",
              // lineHeight: "34px",
              display: "flex",
              flexDirection: "column",
              margin: 0,
              marginBottom: 0,
              // fontSize: "1.3em",
              fontWeight: "bold",
              color: "#555",
            }}
          >
            News
          </p>
        </div>
        {/* <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          {newsData.map((news, index) => (
            <NewsCard key={index} {...news} />
          ))}
          <div className=".news-card"></div>
        </div> */}
        {/* <div
          style={{
            display: "flex",
            flexDirection: "column", // Switch to column for list layout
            justifyContent: "center", // Center the list items
            alignItems: "center", // Align the items horizontally in the center
          }}
        >
          {newsData.map((news, index) => (
            <NewsCard key={index} {...news} />
          ))}
        </div> */}
        <List>
          {newsData.map((news, index) => (
            <ListItem key={index}>
              <NewsCard {...news} />
            </ListItem>
          ))}
        </List>

        {/* <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "20px", // Optional: Adds spacing between items
          }}
        >
          {newsData.map((news, index) => (
            <div
              key={index}
              style={{ width: "30%", minWidth: "280px", flex: "1 1 30%" }}
            >
              <div className="news-title">{news.title}</div>
              <div className="news-content">
                <p className="news-text">{news.text}</p>
                // {/* <div
                //   className="read-more"
                //   onClick={() => console.log(news.title)}
                // >
                //   Read More
                // </div> */}
        {/* </div>
            </div> */}
        {/* ))} */}
        {/* </div> */}
        {/* <MovieContainer data={Upcoming} text={"Upcoming"} />
        <MovieContainer data={released} text={"Released"} /> */}
      </GradientWrapper>
      <Footer />
    </>
  );
};

export default Home;
